import { render, staticRenderFns } from "./ListaPreciosVentaCrud.vue?vue&type=template&id=41572f04&"
import script from "./ListaPreciosVentaCrud.vue?vue&type=script&lang=js&"
export * from "./ListaPreciosVentaCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports